"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrgGroup = createOrgGroup;
exports.deleteOrgGroup = deleteOrgGroup;
exports.getOrgGroupById = getOrgGroupById;
exports.getOrgGroupResTree = getOrgGroupResTree;
exports.queryOrgGroupALL = queryOrgGroupALL;
exports.queryOrgGroupList = queryOrgGroupList;
exports.saveOrgGroupRes = saveOrgGroupRes;
exports.updateOrgGroup = updateOrgGroup;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
// 获取组织角色列表
function queryOrgGroupList(query) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroup/page',
    method: 'get',
    params: query
  });
}

// 获取组织角色 - 全部数据
function queryOrgGroupALL() {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroup/all',
    method: 'get'
  });
}

// 创建组织角色
function createOrgGroup(data) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroup',
    method: 'post',
    data: data
  });
}

// 更新组织角色信息
function updateOrgGroup(data) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroup',
    method: 'put',
    data: data
  });
}

// 删除组织角色信息
function deleteOrgGroup(id) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroup/delete',
    method: 'delete',
    params: {
      orgGroupId: id
    }
  });
}

// 通过id查询组织角色信息
function getOrgGroupById(id) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroup/' + id,
    method: 'get'
  });
}

// 保存组织角色资源关系
function saveOrgGroupRes(data) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroupResRel',
    method: 'post',
    data: data
  });
}

// 获取资源树和组织角色资源关系
function getOrgGroupResTree(query) {
  return (0, _requestAuth.default)({
    url: '/sysOrgGroupResRel/tree',
    method: 'get',
    params: query
  });
}